
export default {
  name: 'AggregateRating',
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  computed: {
    schema() {
      return JSON
        .stringify({
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        "url": "https://echowave.io",
        "name": `EchoWave, ${this.page.attributes.title}`,
        "description": this.page.attributes.description,
        "operatingSystem": "Windows, MacOS, Chrome OS, Linux, iOS, Android",
        "applicationCategory": "MultimediaApplication",
        "applicationSubCategory": "Video Editor",
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.8,
          "bestRating": 5,
          "ratingCount": 137
        },
        "offers": {
          "@type": "Offer",
          "price": 0,
          "priceCurrency": "USD"
        }
      })
    },
  },
}
